export default __webpack_public_path__ + "static/media/schoolDate3.7e637046.png";